// LE
import lePinDefault from './lpcDefault.svg'
import lePinPreviewed from './lpcViewed.svg'

// Bedbank on LE
import leBedbankPinDefault from './bedbankDefault.svg'
import leBedbankPinPreviewed from './bedbankViewed.svg'

// Flash on LE
import leFlashPinDefault from './flashDefault.svg'
import leFlashPinPreviewed from './flashViewed.svg'
import selectedMarker from './selectedMarker.svg'
import flashSoldOutDefault from './flashSoldOutDefault.svg'
import flashSoldOutViewed from './flashSoldOutViewed.svg'

// Sold out
import soldOutPinDefault from './soldOutDefault.svg'
import soldOutPinDefaultHover from './soldOutDefaultHover.png'
import soldOutPinActive from './soldOutSelected.svg'
import soldOutPinPreviewed from './soldOutViewed.svg'
import soldOutPinPreviewedHover from './soldOutPreviewedHover.png'

// LED (placeholder)
import pinUnbranded from './pinDefault.png'
import pinUnbrandedActive from './pinActive.png'
import config from 'constants/config'
import { OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL } from 'constants/offer'

export interface PinSizing {
  size: [number, number]
  anchor: [number, number]
}

interface Pin {
  image: string
  sizing: PinSizing
}

interface PropertyMarkerPinState {
  active: boolean
  visited: boolean
  soldOut: boolean
  isHovered?: boolean
}

interface PinType {
  default: Pin
  hover: Pin
}

interface PinConfig {
  pinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  flashPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  bedbankPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  soldOutPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  flashSoldOutPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
}

const leDefaultSize: PinSizing = {
  // [width, height]
  size: [38, 48],

  // [left, top]
  anchor: [19, 46],
}

const selectedMarkerSize: PinSizing = {
  size: [44, 55],
  anchor: [22, 47],
}

const flashSoldOutMarkerSize: PinSizing = {
  size: [68, 80],
  anchor: [34, 56],
}

const bedbankDefaultSize: PinSizing = {
  size: [35, 43],
  anchor: [18, 41],
}

const bedbankExpandSize: PinSizing = {
  size: [39, 48],
  anchor: [20, 41],
}

const soldOutDefaultSize: PinSizing = {
  size: [32, 38],
  anchor: [16, 36],
}

const soldOutExpandSize: PinSizing = {
  size: [36, 43],
  anchor: [18, 41],
}

const unbrandedSize: PinSizing = {
  size: [28, 31],
  anchor: [14, 28],
}

const unbrandedSmallSize: PinSizing = {
  size: [18, 20],
  anchor: [9, 18],
}

const brandPins: { [brand: string]: PinConfig } = {
  luxuryescapes: {
    pinIcons: {
      default: {
        default: {
          image: lePinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: lePinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: leFlashPinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: leFlashPinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: leBedbankPinDefault,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
      previewed: {
        default: {
          image: leBedbankPinPreviewed,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: soldOutPinDefault,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinDefaultHover,
          sizing: soldOutExpandSize,
        },
      },
      active: {
        default: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
        hover: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
      },
      previewed: {
        default: {
          image: soldOutPinPreviewed,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinPreviewedHover,
          sizing: soldOutExpandSize,
        },
      },
    },
    flashSoldOutPinIcons: {
      default: {
        default: {
          image: flashSoldOutDefault,
          sizing: flashSoldOutMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: soldOutExpandSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: flashSoldOutViewed,
          sizing: flashSoldOutMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
  },
  default: {
    pinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    flashSoldOutPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
  },
}

function getPropertyPinIcons(
  marker: App.MapMarkerV2,
  soldOut: boolean,
): PinConfig['pinIcons'] | PinConfig['flashPinIcons'] | PinConfig['bedbankPinIcons'] | PinConfig['soldOutPinIcons'] | PinConfig['flashSoldOutPinIcons'] {
  const isAllBedbank = marker.offers.every(offer => offer.type === OFFER_TYPE_BED_BANK)
  const isAllFlash = marker.offers.every(offer => offer.type === OFFER_TYPE_HOTEL)
  const brandPinConfig = brandPins[config.BRAND] ?? brandPins.default

  if (soldOut && isAllFlash) {
    return brandPinConfig.flashSoldOutPinIcons
  }

  if (soldOut) {
    return brandPinConfig.soldOutPinIcons
  }

  if (isAllBedbank) {
    return brandPinConfig.bedbankPinIcons
  }

  if (isAllFlash) {
    return brandPinConfig.flashPinIcons
  }

  return brandPinConfig.pinIcons
}

export function getPropertyMarkerPin(
  marker: App.MapMarkerV2,
  {
    active,
    visited,
    soldOut,
    isHovered = false,
  }: PropertyMarkerPinState,
): Pin {
  const pinIcons = getPropertyPinIcons(marker, soldOut)

  let pinVersion = pinIcons.default
  if (active || isHovered) {
    pinVersion = pinIcons.active
  } else if (visited) {
    pinVersion = pinIcons.previewed
  }

  return (isHovered && !active) ? pinVersion.hover : pinVersion.default
}

export function getPropertyMarkerFrameSize(sizing: PinSizing): [number, number] {
  const [width, height] = sizing.size

  // Some legacy pin assets define the visual anchor below the rendered image, so
  // the outer marker box must be tall enough to contain the anchor point itself.
  return [width, Math.max(height, sizing.anchor[1])]
}

export function getPropertyMarkerMapboxOffset(
  marker: App.MapMarkerV2,
  pinState: PropertyMarkerPinState,
): [number, number] {
  const { sizing } = getPropertyMarkerPin(marker, pinState)
  const [width, frameHeight] = getPropertyMarkerFrameSize(sizing)

  // Let Mapbox own the geographic anchoring and compensate in one place via
  // Marker.offset, instead of stacking wrapper transforms above the pin asset.
  return [
    Math.round(width / 2 - sizing.anchor[0]),
    frameHeight - sizing.anchor[1],
  ]
}

export default brandPins
